import { Logo } from "@components/atoms";
import { Text } from "@components/atoms";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "@shared/constants";

/**
 * Footer organism.
 * 168px tall, secondary-120 background.
 * Left: blue logo. Center: FAQ and Contact links. Right: legal text.
 */
export function Footer() {
  const navigate = useNavigate();
  return (
    <footer
      className="w-full bg-secondary-120 px-6 sm:px-12 lg:px-20 py-8 md:py-0 flex flex-col md:flex-row md:items-center md:justify-between gap-8 md:gap-0"
      style={{ minHeight: 168 }}
    >
      {/* Left — Blue logo */}
      <div className="flex items-center">
        <Logo variant="blue" width={160} />
      </div>

      {/* Center — Links */}
      <div className="flex flex-col items-start gap-0">
        <button
          className="cursor-pointer border-none bg-transparent py-2"
          onClick={() => navigate("/faq")}
        >
          <Text
            variant="body"
            as="span"
            className="font-semibold text-primary-110"
            style={{ fontSize: 17 }}
          >
            Preguntas Frecuentes
          </Text>
        </button>
        <div className="h-px bg-primary-110/20 w-full max-w-[330px]" />
        <button
          className="cursor-pointer border-none bg-transparent py-2"
          onClick={() => navigate("/contact")}
        >
          <Text
            variant="body"
            as="span"
            className="font-semibold text-primary-110"
            style={{ fontSize: 17 }}
          >
            Contáctanos
          </Text>
        </button>
        <div className="h-px bg-primary-110/20 w-full max-w-[330px]" />
      </div>

      {/* Right — Legal + contact email */}
      <div className="flex flex-col items-start gap-1">
        <button
          className="cursor-pointer border-none bg-transparent p-0 text-left"
          onClick={() => navigate(ROUTES.PRIVACY)}
        >
          <Text variant="body-sm" as="span" className="text-primary-110 hover:underline">
            Protección de datos personales
          </Text>
        </button>
        <button
          className="cursor-pointer border-none bg-transparent p-0 text-left"
          onClick={() => navigate(ROUTES.TERMS)}
        >
          <Text variant="body-sm" as="span" className="text-primary-110 hover:underline">
            Términos y Condiciones
          </Text>
        </button>
        <Text variant="body-sm" as="span" className="text-primary-110">
          Contáctanos: info@ticketin.ec
        </Text>
        <Text variant="body-sm" as="span" className="text-primary-110">
          Todos los derechos reservados 2026
        </Text>
      </div>
    </footer>
  );
}
